import { Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { CodeBlock } from '../code-block';
import { handleCopyClick } from '../constants';
import { StyleGuidePage } from '../style-guide-page';

export const StyleGuidePageComponent = () => {
  const [isCopied, setIsCopied] = useState<{
    [val: string]: boolean;
  }>({});

  return (
    <StyleGuidePage title="Page Components">
      <Grid container mb={2}>
        <Grid item xs={12} lg={8}>
          <Typography mb={1}>
            The page component is the basis on which all pages are built. It handles the document
            title (browser title) rendering, as well as breadcrumbs. It also houses references and
            logic pertaining to the side navigation, the header, and footer components.
          </Typography>
          <Typography mb={1}>
            This component will be the most used to create new pages in the application. However,
            there are other page type components created for different areas of the application that
            you should be aware of when developing:
            <ul>
              <li>
                <strong>OrderManagementPage</strong>: For rendering different sidebar navigation
                links based on permissions, built upon Page component
              </li>
              <li>
                <strong>VendorPage</strong>: For rendering Vendor Portal pages, includes a Vendor
                selector in the top right of the screen for switching/filtering by Vendor, and
                includes logic for Page Title Back Button, breadcrumbs, and document/browser title
              </li>
              <li>
                <strong>MinimalPage</strong>: For external pages, such as the Login and Forgot
                Password, with no header or footer rendered
              </li>
              <li>
                <strong>TemplatePage</strong>: For building checklist template page
              </li>
              <li>
                <strong>StyleGuidePage</strong>: For rendering the style guide navigation, built
                upon the Page component
              </li>
            </ul>
          </Typography>
          <code>
            Props:
            <br />- children: any
            <br />- title: string <br />- showSideBar?: boolean
            <br />- showBreadcrumbs?: boolean
            <br />- sideBarLinks?: INavLink[]
            <br />- isModal?: boolean
            <br />- hasNoContentPadding?: boolean
            <br />- forceMobileNav?: boolean
            <br />- disableDesktopCollapse?: boolean
            <br />- showHelp?: boolean
            <br />- printOrientation?: 'portrait' | 'landscape'
          </code>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CodeBlock handleCopyClick={e => handleCopyClick(setIsCopied, e)} isCopied={isCopied}>
            &lt;Page title="Custom Page Title"&gt;Page Content Goes Here&lt;/Page&gt;
          </CodeBlock>
        </Grid>
      </Grid>
    </StyleGuidePage>
  );
};
